import DashboardFilters from './DashboardFilters';

export default DashboardFilters;
